<script setup>
import ExplainDirective from '@/Pages/DomainAnalysis/Partials/ExplainDirective.vue';
import DKIMDirectiveMessaging from '@/Common/Classifiers/DKIMDirectiveMessaging.js';

defineProps({
  title: String,
  directive: Object
});
</script>

<template>
  <ExplainDirective
    :classifier="DKIMDirectiveMessaging"
    :title="title"
    :directive="directive"
  />
</template>
